import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { HOME } from "@/constants/testIds";

export default function HeroCallouts() {
  return (
    <div className="mt-12 flex flex-wrap items-center gap-5 opacity-0 animate-[fade-up_0.9s_1.35s_forwards]">
      <Link
        to="/destinations"
        data-testid={HOME.heroCta}
        className="group inline-flex items-center gap-3 bg-ivory text-ink px-8 py-4 text-[11px] tracking-widest2 uppercase font-semibold hover:bg-goldleaf transition-colors"
      >
        Explore Destinations
        <ArrowUpRight
          size={16}
          className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
        />
      </Link>
      <Link
        to="/contact"
        className="inline-flex items-center gap-2 text-ivory text-[11px] tracking-widest2 uppercase border-b border-ivory/50 pb-1 hover:text-goldleaf hover:border-goldleaf transition-colors"
      >
        Speak with a Curator
      </Link>
    </div>
  );
}
